import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import MemoriesAlbumView from '../components/MemoriesAlbumView';
import { DOCUMENT, PAGE_CONTAINER_MAX_WIDTH, documentPageContainerSx } from '../constants/documentTheme';

const MemoriesEvent = () => {
  const { slug } = useParams();
  return (
    <Box sx={{ backgroundColor: DOCUMENT.canvas, minHeight: '100vh', pb: 8 }}>
      <Container maxWidth={PAGE_CONTAINER_MAX_WIDTH} sx={{ ...documentPageContainerSx, pt: 3 }}>
        <MemoriesAlbumView slug={slug} />
      </Container>
    </Box>
  );
};

export default MemoriesEvent;
